export class Pagination {

    total: number

    pageCount: number

    currentPageIndex: number

    bucketPages: Array<number>

    bucketCount: number

    currentBucketIndex: number

    hasNextBucket: boolean

    hasPrevBucket: boolean

    hasNextPage: boolean

    hasPrevPage: boolean

    offset: number

    /*
    get visiblePages():Array<number> {

        return [1]
    }
    */
    //constructor(public pageSize: number, public bucketSize: number, public total: number, currentPageIndex: number) {
    constructor(public pageSize: number, public bucketSize: number) {
        //this.updateCurrentPageIndex(currentPageIndex)
        //this.pageCount = total/pageSize
    }

    public calculateOffsetByBucketIndex(bucketIndex: number): number {
        return this.calculateOffset(bucketIndex * this.bucketSize)
    }

    public calculateOffset(pageIndex: number): number {
        return pageIndex * this.pageSize
    }

    public calculatePageIndex(offset: number): number {
        return Math.floor(offset / this.pageSize)
    }

    public updateByOffset(total: number, offset: number) {
        this.offset = offset
        this.currentPageIndex = this.calculatePageIndex(offset)
        this.update(total)
    }

    public updateByPageIndex(total: number, currentPageIndex: number) {
        this.currentPageIndex = currentPageIndex
        this.offset = this.calculateOffset(currentPageIndex)
        this.update(total)
    }
    private update(total: number) {
        this.total = total
        this.pageCount = Math.ceil(this.total / this.pageSize)
        this.hasNextPage = (this.pageCount - this.currentPageIndex) > 1
        this.hasPrevPage = this.currentPageIndex != 0
        this.bucketCount = Math.ceil(this.pageCount / this.bucketSize)
        this.currentBucketIndex = Math.floor(this.currentPageIndex / this.bucketSize)
        const nextBucketIndex = this.currentBucketIndex + 1
        const maxPageIndexInBucket = Math.min(this.pageCount, nextBucketIndex * this.bucketSize)
        this.bucketPages = []
        for (let i = this.currentBucketIndex * this.bucketSize; i < maxPageIndexInBucket; i++) {
            this.bucketPages.push(i)
        }
        this.hasNextBucket = (this.bucketCount - this.currentBucketIndex) > 1
        this.hasPrevBucket = this.currentBucketIndex != 0
        console.log(
            "Current page:%s - page count:%s - bucketCount:%s - current BucketIndex:%s - maxPageCountInBucket:%s - bucket pages:%s - has prev bucket:%s has next bucket:%s",
            this.currentPageIndex, this.pageCount, this.bucketCount, this.currentBucketIndex, maxPageIndexInBucket, this.bucketPages.join(','), this.hasPrevBucket, this.hasNextBucket
        )
    }

}